var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1549",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 10.7778C13.9547 10.7778 15.9446 8.78796 15.9446 6.33336C15.9446 3.87876 13.9547 1.88892 11.5001 1.88892C9.04551 1.88892 7.05566 3.87876 7.05566 6.33336C7.05566 8.78796 9.04551 10.7778 11.5001 10.7778Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 24.1111C21.5 18.5883 17.0228 14.1111 11.5 14.1111C5.97722 14.1111 1.5 18.5883 1.5 24.1111",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4996 24.1111L13.7218 21.3333L11.4996 14.1111L9.27734 21.3333L11.4996 24.1111Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.83301 -0.333252H24.8337V26.3334H-1.83301V-0.333252Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDetailsIcon);
export default __webpack_public_path__ + "static/media/CompanyDetailsIcon.f8937bab97ad3e5b8201df7b97e90ef9.svg";
export { ForwardRef as ReactComponent };